(function () {

  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
  }

  // Toggle Wishlist
  window.toggleWishlist = function(handle){

    let wishlist = getWishlist();

    if(wishlist.includes(handle)){
      wishlist = wishlist.filter(item => item !== handle);
    }else{
      wishlist.push(handle);
    }

    saveWishlist(wishlist);

    updateWishlistIcons();
    updateWishlistCount();

  };

  // Update Heart Icons
  function updateWishlistIcons(){

    let wishlist = getWishlist();

    document.querySelectorAll(".wishlist-btn").forEach(function(btn){

      let handle = btn.dataset.handle;

      if(wishlist.includes(handle)){
        btn.classList.add("active");
      }else{
        btn.classList.remove("active");
      }

    });

  }

  // Update Header Wishlist Count
  function updateWishlistCount(){

    let wishlist = getWishlist();

    // Remove invalid numeric values if any
    wishlist = wishlist.filter(item => isNaN(item));

    document.querySelectorAll(".wishlist-count").forEach(function(badge){
      badge.textContent = wishlist.length;
    });

  }

  // Initial Load
  document.addEventListener("DOMContentLoaded", function(){

    updateWishlistIcons();
    updateWishlistCount();

  });

})();